import React, { useEffect } from 'react';
import '../../App.css';
import '../../New-App.css';
import '../../style/mui.css';
import Navbar from '@components/Navigation/Navbar';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Snackbar from '@components/snackbar/Snackbar';
import BaseDialog from '@model/common/dialog/BaseDialog';
import {
  FullScreenSpinner,
  HcLinearAuthenticationProvider,
  Suspense,
  SuspenseFallbackType,
} from '@hclinear/hc-linear-react';
import { Outlet, useLocation, useMatch, useNavigate } from '@tanstack/react-router';
import { APP_ROUTES } from '@/util';
import Gem from '@/lib/gem';

export default function RootLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const isLayoutEditor = useMatch({
    from: APP_ROUTES.TEMPLATES.LAYOUT_EDITOR,
    shouldThrow: false,
  });

  const isTimeTableEditor = useMatch({
    from: APP_ROUTES.TEMPLATES.TIMETABLE_EDITOR,
    shouldThrow: false,
  });

  const isAnnouncementEditor = useMatch({
    from: APP_ROUTES.ANNOUNCEMENTS.EDITOR,
    shouldThrow: false,
  });

  const defaultTheme = createTheme({
    typography: {
      fontFamily: 'Poppins',
    },
    components: {
      MuiTooltip: {
        defaultProps: {
          disableInteractive: true,
        },
      },
    },
  });

  useEffect(() => {
    if (location.pathname === APP_ROUTES.HOME) {
      navigate({ to: APP_ROUTES.DASHBOARD });
    }
  }, []);

  const isNavbarHidden = isLayoutEditor || isTimeTableEditor || isAnnouncementEditor;

  const content = (
    <ThemeProvider theme={defaultTheme}>
      <header>{!isNavbarHidden && <Navbar />}</header>
      <main>
        <div className='page-content-body'>
          <Suspense fallbackType={SuspenseFallbackType.FULLSCREEN_SPINNER}>
            <Outlet />
          </Suspense>
          <BaseDialog />
        </div>
      </main>
      <Snackbar />
      <Gem />
    </ThemeProvider>
  );

  return (
    <div className='App'>
      <HcLinearAuthenticationProvider
        navigate={(path: string) => navigate({ to: path })}
        locationConfig={{
          pathname: location.pathname,
          search: location.searchStr,
        }}
        fallback={<FullScreenSpinner openProp />}
      >
        {content}
      </HcLinearAuthenticationProvider>
    </div>
  );
}
